import { z } from 'zod';

import { BlockType } from './base/baseSchema.js';

export const MoneySchema = z.object({
  amount: z.string().regex(/^\d+(\.\d+)?$/),
  currency: z.enum(['USD']),
});

export type Money = z.infer<typeof MoneySchema>;

export const FlowRunCostResponseSchema = z.object({
  flowRunId: z.string(),
  totalCost: MoneySchema,
  blockLineItems: z.array(
    z.object({
      blockType: z.nativeEnum(BlockType),
      totalCost: MoneySchema,
      lineItems: z.array(
        z.object({
          totalCost: MoneySchema,
          unitCostDescription: z.string(),
          usageDescription: z.string(),
        })
      ),
    })
  ),
  subflowLineItems: z.array(
    z.object({
      name: z.string(),
      totalCost: MoneySchema,
      flowRunId: z.string(),
    })
  ),
  pendingRateLineItems: z.array(
    z.object({
      blockType: z.nativeEnum(BlockType),
    })
  ),
});

export type FlowRunCostResponse = z.infer<typeof FlowRunCostResponseSchema>;
